import { render, staticRenderFns } from "./SplitList.vue?vue&type=template&id=2eb7533a&scoped=true&"
import script from "./SplitList.vue?vue&type=script&lang=ts&"
export * from "./SplitList.vue?vue&type=script&lang=ts&"
import style0 from "./SplitList.vue?vue&type=style&index=0&id=2eb7533a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb7533a",
  null
  
)

export default component.exports